import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateProjectSource } from "../../models/projectsources/CreateProjectSource";
import { UpdateProjectSource } from "../../models/projectsources/UpdateProjectSource";

const RESOURCE_NAME = 'projectsource';

const getAll = () => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}/getAll`, requestConfig());
  };

const create = (model: CreateProjectSource) => {
    const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/create`, model, requestConfig());
};

const update = (model: UpdateProjectSource) => {
    const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/update/${model.id}`, model, requestConfig());
};

const remove = (id: number) => {
    const http = getAxiosInstance();
    return http.delete(`${RESOURCE_NAME}/delete/${id}`, requestConfig());
  }

const ProjectSourceService = {
  getAll,
  create,
  update,
  remove,
};
export default ProjectSourceService;